import * as Icon from '@58fe/v5-icon';

function firstUpperCase(word) {
	return word.replace(/^\S/, s => s.toUpperCase());
}

function tranleater(str) {
	return Array.from(str.split('-'))
		.map(val => firstUpperCase(val))
		.join('');
}
export default {
	name: 'v5-icon',
	props: {
		type: {
			type: String,
			required: true
		}
	},
	render(h) {
		const name = tranleater(this.type);
		return h(Icon[name]);
	}
};
